import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(function shortAddress([address], { start = 16, end = 5 } = {}) {
  if (!address || typeof address !== 'string') return '';
  if (address.length <= start + end) return address;
  return `${address.slice(0, start)}...${address.slice(-end)}`;
});